type TenantNode = {
  id?: string;
  subTenants?: TenantNode[];
};

export function countSelectableTenants(tenants: TenantNode[] | undefined): number {
  return (
    tenants?.reduce((count, tenant) => count + 1 + countSelectableTenants(tenant.subTenants), 0) ??
    0
  );
}
